<template>
  <div :class="sizeClass" class="spinner">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
</template>

<script>
/**
 * Компонент для отображения процесса загрузки с возможностью настройки размера.
 */
export default {
  props: {
    /**
     * Вариант размера элемента.
     *
     * @values l, s
     */
    size: {
      type: String,
      default: "l",
    },
  },
  computed: {
    sizeClass() {
      const sizeClasses = {
        "l": "spinner_large",
        "s": "spinner_small",
      };
      return _.get(sizeClasses, this.size, "spinner_large");
    },
  },
};
</script>

<style lang="scss">
@use "./style.scss";
</style>
